import React, { useState } from "react";

export default function RentTaxCalculator() {
  const [rent, setRent] = useState(0);
  const [months, setMonths] = useState(1);
  const [late, setLate] = useState(false);
  const [result, setResult] = useState(null);

  function calculateTax(e) {
    e.preventDefault();
    const grossRent = rent * months;
    const baseTax = grossRent * 0.1;
    const penalty = late ? baseTax * 0.1 : 0;
    const totalPayable = baseTax + penalty;
    setResult({ grossRent, baseTax, penalty, totalPayable });
  }

  return (
    <div
      className="rent-tax-calc"
      style={{
        background: "var(--bg)",
        borderRadius: 12,
        boxShadow: "var(--shadow-xs)",
        padding: "1.5rem 1.2rem",
        margin: "2.2rem 0 2.5rem 0",
        maxWidth: 420,
      }}
    >
      <h3
        style={{
          color: "var(--sky-700)",
          fontWeight: 700,
          fontSize: "1.2rem",
          marginBottom: 12,
        }}
      >
        Nepal Rent Tax Calculator
      </h3>
      <form
        onSubmit={calculateTax}
        style={{ display: "flex", flexDirection: "column", gap: 12 }}
      >
        <label style={{ color: "var(--ink-700)", fontWeight: 500 }}>
          Monthly Rent (NPR):
          <input
            type="number"
            min="0"
            value={rent}
            onChange={(e) => setRent(Number(e.target.value))}
            style={{
              marginLeft: 8,
              padding: 4,
              borderRadius: 6,
              border: "1px solid var(--line)",
            }}
          />
        </label>
        <label style={{ color: "var(--ink-700)", fontWeight: 500 }}>
          Number of Months:
          <input
            type="number"
            min="1"
            value={months}
            onChange={(e) => setMonths(Number(e.target.value))}
            style={{
              marginLeft: 8,
              padding: 4,
              borderRadius: 6,
              border: "1px solid var(--line)",
            }}
          />
        </label>
        <label
          style={{
            color: "var(--ink-700)",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type="checkbox"
            checked={late}
            onChange={(e) => setLate(e.target.checked)}
            style={{ marginRight: 6 }}
          />
          Add 10% Late Payment Penalty
        </label>
        <button
          type="submit"
          style={{
            background: "var(--sky-700)",
            color: "white",
            border: "none",
            borderRadius: 8,
            padding: "0.5rem 1.2rem",
            fontWeight: 600,
            fontSize: "1rem",
            cursor: "pointer",
            marginTop: 8,
          }}
        >
          Calculate Tax
        </button>
      </form>
      {result && (
        <div
          id="resultBox"
          style={{
            marginTop: 18,
            background: "var(--paper)",
            borderRadius: 8,
            padding: "1rem 0.8rem",
            boxShadow: "var(--shadow-xs)",
          }}
        >
          <div
            style={{
              color: "var(--ink-900)",
              fontWeight: 600,
              marginBottom: 4,
            }}
          >
            Total Gross Rent:{" "}
            <span style={{ color: "var(--sky-700)" }}>
              Rs. {result.grossRent.toLocaleString("en-IN")}
            </span>
          </div>
          <div style={{ color: "var(--ink-700)", marginBottom: 2 }}>
            Base Tax (10%):{" "}
            <b style={{ color: "var(--sun-500)" }}>
              Rs. {result.baseTax.toLocaleString("en-IN")}
            </b>
          </div>
          <div style={{ color: "var(--ink-700)", marginBottom: 2 }}>
            Late Penalties:{" "}
            <b style={{ color: "var(--sun-500)" }}>
              Rs. {result.penalty.toLocaleString("en-IN")}
            </b>
          </div>
          <div
            style={{
              color: "var(--ink-900)",
              fontWeight: 700,
              fontSize: "1.1rem",
              marginTop: 8,
            }}
          >
            Total Payable:{" "}
            <span style={{ color: "var(--sky-700)" }}>
              Rs. {result.totalPayable.toLocaleString("en-IN")}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
